import { HttpModelConverter } from '../../../../../../core/converter/httpModel.converter';
import { Injectable } from '@angular/core';
import { WorkflowTaskModel } from '../workflowTask.model';
import { WorkflowTaskSummaryConverter } from './workflowTaskSummary.converter';
import {
    DiscussionSummaryConverter
} from '../../../../../../discussion/modules/common/api/converter/discussionSummary.converter';
import {WorkflowTaskChildSummaryConverter} from "../../child/converter/workflowTaskChildSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class WorkflowTaskConverter extends HttpModelConverter<WorkflowTaskModel> {

    constructor(
        private summaryConverter: WorkflowTaskSummaryConverter,
        private discussionSummaryConverter: DiscussionSummaryConverter,
        private childSummaryConverter: WorkflowTaskChildSummaryConverter) {
        super();
    }

    protected createInstance(): WorkflowTaskModel {
        return new WorkflowTaskModel();
    }

    protected enrichObject(result: WorkflowTaskModel, src: WorkflowTaskModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.discussion = this.discussionSummaryConverter.convert(src.discussion);
        result.children = this.childSummaryConverter.convertFromArray(src.children);
    }


}
